/**
 * Single source of truth for company identity used on ALL print templates
 * (PO, DC, Invoice, SPO, etc.).
 *
 * Values mirror what is hardcoded in `frontend/src/components/POPrint.js`
 * (lines 261-264). If the company details change, update BOTH this file and
 * the POPrint template in lockstep, OR migrate both to a `/api/company-profile`
 * endpoint backed by DB.
 */
export const COMPANY_PROFILE = {
  name: "DREAMSPAN VENTURES PRIVATE LIMITED",
  address_line_1: "556/1/2, Balaji Hotel Lane, Pisoli",
  address_line_2: "Katraj Kondhwa Road, Pune-411060",
  gstin: "27AAHCD8512E1ZR",
};
